import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType, } from 'api/utils/RepositoryTypes';

export interface InfoType {
    code: string,
    maintenance: {
        startsAt: string,
        endsAt: string,
        message: string,
    } | null,
}

class InfoRepository extends BaseRepositoryClass implements RepositoryType {
    get() {
        return this
            .requester
            .get<InfoType>('info');
    }
}

export default InfoRepository;
